<app-formulario #ctrl URL="empresa-configuracion" titulo="Configuración / Empresa" [dato]="dato"></app-formulario>
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">
  <div class="column is-2 is-hidden-mobile menu-izquierda">
    <app-sistema-menu-aside></app-sistema-menu-aside>
  </div>
  <div class="column" style="padding:0em;">
    <div style="background: #FFF; border-radius: 0em; ">
      <!-- formulario -->
      <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar();  ctrl.cambiar_sucursal();">
        <section class="hero is-primary">
          <div class="hero-body">
            <app-formulario-opciones [ctrl]="ctrl" [id]="ctrl.dato.id"></app-formulario-opciones>
          </div>
        </section>

        <section class="section" style="overflow: auto;padding: 1rem !important;height: 87.3vh;" formGroupName='configuracion'>

          <!-- cargar los catalogos que se requieran parametro 1 modelo donde se guarda el catalogo, parametro 2 ruta de la api -->
          <a id="catalogos" (click)="ctrl.cargarCatalogo('tipos_medios', 'tipo-medio'); ctrl.cargarCatalogo('tipos_redes_sociales', 'tipo-red-social');
                     ctrl.cargarCatalogo('tipos_monedas', CFDI_PATH+'/api/v1/catalogo-moneda', '', 'clave');
                     ctrl.cargarCatalogo('catalogos_impuestos', CFDI_PATH+'/api/v1/catalogo-impuesto', '', 'clave');
                     ctrl.cargarCatalogo('catalogos_factores', CFDI_PATH+'/api/v1/catalogo-factor', '', 'clave');
                     ctrl.subir['logo'] = false; ctrl.subir['fondo'] = false;">

          </a>
          <a id="regimen" (click)="ctrl.cargarCatalogo('catalogos_regimenes_fiscales', CFDI_PATH+'/api/v1/catalogo-regimen-fiscal?persona='+ctrl.dato.controls.configuracion.controls.facturacion.controls.persona.value, '', 'clave');"></a>


          <div class="tabs is-boxed">
            <ul>
              <li [ngClass]="{ 'is-active' : tab == 1}">
                <a (click)="tab=1">
                  <span class="icon ">
                    <i class="fa fa-home"></i>
                  </span>
                  <span>General</span>
                </a>
              </li>

              <li [ngClass]="{ 'is-active' : tab == 2}">
                <a (click)="tab=2">
                  <span class="icon ">
                    <i class="fa fa-building"></i>
                  </span>
                  <span>Empresa</span>
                </a>
              </li>

              <li [ngClass]="{ 'is-active' : tab == 3}">
                <a (click)="tab=3">
                  <span class="icon ">
                    <i class="fa fa-user"></i>
                  </span>
                  <span>Contacto</span>
                </a>
              </li>


            </ul>
          </div>

          <!-- general -->
          <div [ngClass]="{ 'is-hidden': tab != 1}">
            <div class="columns">
              <div class="column is-6">
                <div class="field">
                  <label class="label">Empresa:</label>
                  <div class="control has-icons-left has-icons-right">
                    <input class="input" type="text" placeholder="nombre" formControlName="nombre">
                  </div>
                </div>
              </div>
              <div class="column is-6">
                <div class="field">
                  <label class="label">Nombre:</label>
                  <div class="control has-icons-left has-icons-right">
                    <input class="input" type="text" placeholder="subnombre" formControlName="subnombre">
                  </div>
                </div>
              </div>
            </div>

            <div class="columns">
              <div class="column is-4">
                <div class="field">
                  <label class="label">Sitio:</label>
                  <div class="control has-icons-left has-icons-right">
                    <input class="input" type="text" placeholder="sitio" formControlName="sitio">
                  </div>
                </div>
              </div>
              <div class="column is-4">
                <div class="field">
                  <label class="label">Telefono:</label>
                  <div class="control has-icons-left has-icons-right">
                    <input class="input" type="text" placeholder="telefono" formControlName="telefono">
                  </div>
                </div>
              </div>
              <div class="column is-4">
                <div class="field">
                  <label class="label">Correo:</label>
                  <div class="control has-icons-left has-icons-right">
                    <input class="input" type="text" placeholder="correo" formControlName="correo">
                  </div>
                </div>
              </div>
            </div>

            <div class="columns">
              <div class="column is-12">
                <div class="field">
                  <label class="label">Dirección:</label>
                  <div class="control has-icons-left has-icons-right">
                    <textarea class="textarea" rows="3" placeholder="Dirección" formControlName="direccion"></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column is-6">

                <div class="box">
                  <article class="media">
                    <div class="media-left">
                      <figure class="image is-64x64">
                        <img *ngIf="ctrl.subir['logo']" [src]="'data:image/jpeg;base64,'+ctrl.dato.get('configuracion').value.logo">
                        <img *ngIf="!ctrl.subir['logo']" [src]="ctrl.dato.get('configuracion').value.logo != '' ? ctrl.API_PATH + '/adjunto/configuracion/' + ctrl.dato.controls.configuracion.controls.logo.value  : './assets/128x128.png'">
                      </figure>
                    </div>
                    <div class="media-content">
                      <div class="field">
                        <label class="label">Logo:</label>
                        <div class="control has-icons-left has-icons-right" *ngIf="ctrl.dato.get('configuracion').value.logo == ''">

                          <div class="file has-name">
                            <label class="file-label">
                              <input type="file" class="file-input" (change)="ctrl.seleccionarImagenBase64($event, ctrl.dato.controls.configuracion.controls.logo, false, 'logo')"
                                accept="image/x-png,image/gif,image/jpeg,image/jpg">
                              <span class="file-cta">
                                <span class="file-icon">
                                  <i class="fa fa-upload"></i>
                                </span>
                                <span class="file-label">
                                  Seleccionar archivo
                                </span>
                              </span>

                            </label>
                          </div>
                        </div>
                        <input foto type="hidden" formControlName="logo">
                        <button type="button" class="button is-danger" (click)="ctrl.borrarImagen($event, ctrl.dato.controls.configuracion.controls.logo, 'configuracion')"
                          *ngIf="ctrl.dato.get('configuracion').value.logo != ''">
                          <span class="icon">
                            <i class="fa fa-trash"></i>
                          </span>
                          &nbsp; Eliminar logo.
                        </button>
                      </div>
                    </div>
                  </article>
                </div>
              </div>

              <div class="column is-6">
                <div class="box">
                  <article class="media">
                    <div class="media-left">
                      <figure class="image is-64x64">
                        <img *ngIf="ctrl.subir['fondo']" [src]="'data:image/jpeg;base64,'+ctrl.dato.get('configuracion').value.fondo">
                        <img *ngIf="!ctrl.subir['fondo']" [src]="ctrl.dato.get('configuracion').value.fondo != '' ? ctrl.API_PATH + '/adjunto/configuracion/' + ctrl.dato.controls.configuracion.controls.fondo.value  : './assets/128x128.png'">
                      </figure>
                    </div>
                    <div class="media-content">
                      <div class="field">
                        <label class="label">Fondo:</label>
                        <div class="control has-icons-left has-icons-right" *ngIf="ctrl.dato.get('configuracion').value.fondo == ''">

                          <div class="file has-name">
                            <label class="file-label">
                              <input type="file" class="file-input" (change)="ctrl.seleccionarImagenBase64($event, ctrl.dato.controls.configuracion.controls.fondo, false, 'fondo')"
                                accept="image/x-png,image/gif,image/jpeg,image/jpg">
                              <span class="file-cta">
                                <span class="file-icon">
                                  <i class="fa fa-upload"></i>
                                </span>
                                <span class="file-label">
                                  Seleccionar archivo
                                </span>
                              </span>

                            </label>
                          </div>
                        </div>
                        <input foto type="hidden" formControlName="fondo">
                        <button type="button" class="button is-danger" (click)="ctrl.borrarImagen($event, ctrl.dato.controls.configuracion.controls.fondo, 'configuracion')"
                          *ngIf="ctrl.dato.get('configuracion').value.fondo != ''">
                          <span class="icon">
                            <i class="fa fa-trash"></i>
                          </span>
                          &nbsp; Eliminar fondo.
                        </button>
                      </div>
                    </div>
                  </article>
                </div>
              </div>

            </div>

            <div class="field">
              <label class="label">Mensaje:</label>
              <div class="control">
                <textarea class="textarea" rows="3" placeholder="Escriba un texto para impresion extra en el ticket"
                  formControlName="mensaje">
                                                        </textarea>
              </div>
            </div>

          </div>

          <!-- empresa -->
          <div [ngClass]="{ 'is-hidden': tab != 2}">
            <div class="tabs is-boxed">
              <ul>
                <li [ngClass]="{ 'is-active' : tab2 == 1}">
                  <a (click)="tab2=1">
                    <span class="icon ">
                      <i class="fa fa-snowflake-o"></i>
                    </span>
                    <span>Quienes somos?</span>
                  </a>
                </li>
                <li [ngClass]="{ 'is-active' : tab2 == 2}">
                  <a (click)="tab2=2">
                    <span class="icon ">
                      <i class="fa fa-snowflake-o"></i>
                    </span>
                    <span>Historia</span>
                  </a>
                </li>
                <li [ngClass]="{ 'is-active' : tab2 == 3}">
                  <a (click)="tab2=3">
                    <span class="icon ">
                      <i class="fa fa-snowflake-o"></i>
                    </span>
                    <span>Misión</span>
                  </a>
                </li>
                <li [ngClass]="{ 'is-active' : tab2 == 4}">
                  <a (click)="tab2=4">
                    <span class="icon ">
                      <i class="fa fa-snowflake-o"></i>
                    </span>
                    <span>Visión</span>
                  </a>
                </li>
                <li [ngClass]="{ 'is-active' : tab2 == 5}">
                  <a (click)="tab2=5">
                    <span class="icon ">
                      <i class="fa fa-snowflake-o"></i>
                    </span>
                    <span>Valores</span>
                  </a>
                </li>
                <li [ngClass]="{ 'is-active' : tab2 == 6}">
                  <a (click)="tab2=6">
                    <span class="icon ">
                      <i class="fa fa-snowflake-o"></i>
                    </span>
                    <span>Pensamientos</span>
                  </a>
                </li>
                <li [ngClass]="{ 'is-active' : tab2 == 7}">
                  <a (click)="tab2=7">
                    <span class="icon ">
                      <i class="fa fa-snowflake-o"></i>
                    </span>
                    <span>Politicas de privacidad</span>
                  </a>
                </li>

                <li [ngClass]="{ 'is-active' : tab2 == 8}">
                  <a (click)="tab2=8">
                    <span class="icon ">
                      <i class="fa fa-snowflake-o"></i>
                    </span>
                    <span>Video</span>
                  </a>
                </li>
              </ul>
            </div>
            <div [ngClass]="{ 'is-hidden': tab2 != 1}">
              <ckeditor formControlName="quienes" debounce="500" [config]="CkeditorConfig"></ckeditor>
            </div>

            <div [ngClass]="{ 'is-hidden': tab2 != 2}">
              <ckeditor formControlName="historia" debounce="500" [config]="CkeditorConfig"></ckeditor>
            </div>

            <div [ngClass]="{ 'is-hidden': tab2 != 3}">
              <ckeditor formControlName="mision" debounce="500" [config]="CkeditorConfig"></ckeditor>
            </div>

            <div [ngClass]="{ 'is-hidden': tab2 != 4}">
              <ckeditor formControlName="vision" debounce="500" [config]="CkeditorConfig"></ckeditor>
            </div>

            <div [ngClass]="{ 'is-hidden': tab2 != 5}">
              <ckeditor formControlName="valores" debounce="500" [config]="CkeditorConfig"></ckeditor>
            </div>

            <div [ngClass]="{ 'is-hidden': tab2 != 6}">
            </div>

            <div [ngClass]="{ 'is-hidden': tab2 != 7}">
              <ckeditor formControlName="privacidad" debounce="500" [config]="CkeditorConfig"></ckeditor>
            </div>

            <div [ngClass]="{ 'is-hidden': tab2 != 8}">
              <nav class="panel">
                <p class="panel-heading">
                  Video promocional
                </p>
              </nav>
              <div class="box" style="margin-top: -20px; border-radius: 0px 0px 8px 8px;" formGroupName="video_promocional">
                <div class="media-content">
                  <div class="content">
                    <div class="columns">
                      <div class="column is-6">
                        <div class="field">
                          <label class="label">Contenedor:</label>
                          <div class="control has-icons-left has-icons-right">
                            <input class="input" type="text" placeholder="Contenedor" formControlName="containment">
                          </div>
                        </div>
                      </div>
                      <div class="column is-6">
                        <div class="field">
                          <label class="label">Video URL:</label>
                          <div class="control has-icons-left has-icons-right">
                            <input class="input" type="text" placeholder="video URL" formControlName="videoURL">
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="columns">
                      <div class="column is-6">
                        <div class="field">
                          <label class="label">Iniciar en el segundo:</label>
                          <div class="control has-icons-left has-icons-right">
                            <input class="input" type="text" placeholder="Iniciar en el segundo" formControlName="startAt">
                          </div>
                        </div>
                      </div>
                      <div class="column is-6">
                        <div class="field">
                          <label class="label">Transparencia:
                            ({{100-(ctrl.dato.controls.configuracion.controls.video_promocional.controls.opacity.value
                            * 100)}}%)</label>
                          <div class="control has-icons-left has-icons-right">
                            <input class="input" type="range" min="0" max="1" step="0.1" placeholder="Transparencia"
                              formControlName="opacity">
                            <span class="icon is-small is-right" [style.opacity]="ctrl.dato.controls.configuracion.controls.video_promocional.controls.opacity.value">
                              <i class="fa fa-check"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="columns">
                      <div class="column is-6">
                        <br>
                        <div class="field">
                          <div class="b-checkbox is-info">
                            <input id="autoPlay" class="styled" type="checkbox" formControlName="autoPlay">
                            <label for="autoPlay">
                              Inicar al cargar la página?
                            </label>
                          </div>
                        </div>
                      </div>

                      <div class="column is-6">
                        <br>
                        <div class="field">
                          <div class="b-checkbox is-info">
                            <input id="mute" class="styled" type="checkbox" formControlName="mute">
                            <label for="mute">
                              Debe tener sonido?
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- contacto y redes -->
          <div [ngClass]="{ 'is-hidden': tab != 3}">
            <!-- contacto -->
            <nav class="panel">
              <p class="panel-heading">
                Medios de contactos
              </p>
              <div class="panel-block">
                <table class="table is-striped  is-fullwidth" *ngIf="ctrl.dato.get('configuracion').value.contactos.length > 0">
                  <thead>
                    <tr>
                      <th hide-sm>ID</th>
                      <th>Red</th>
                      <th>Valor</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody formArrayName="contactos">
                    <tr *ngFor="let medio of ctrl.dato.controls.configuracion.controls.contactos.controls; let suc = index"
                      [formGroupName]="suc">
                      <td>{{ suc + 1 }}</td>
                      <td>
                        <ng-select2 [disabled]="ctrl.tipos_medios ? ctrl.tipos_medios.length == 0 ? true : false : true" [options]="ctrl.optionSelect" [value]="medio.controls.tipos_medios_id.value"
                          (valueChanged)="ctrl.seleccionarValorSelect2($event, medio.controls.tipos_medios_id);" [data]="ctrl.tipos_medios"></ng-select2>
                      </td>
                      <td>
                        <p class="control has-icon" *ngIf="ctrl.tipos_medios">
                          <input class="input" formControlName="valor" placeholder="Valor" [ngClass]="{'is-danger': !medio.controls.valor.valid}"
                            type="text">
                          <span class="icon is-small is-right">
                            <i [ngClass]="ctrl.tipos_medios[medio.controls.tipos_medios_id.value - 1]?.icon"></i>
                          </span>
                        </p>

                      </td>
                      <td align="right">
                        <button type="button" class="button is-danger" (click)="ctrl.quitar_form_array(ctrl.dato.controls.configuracion.controls.contactos, suc)">
                          <i class="fa fa-trash-o"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="button is-primary is-outlined is-fullwidth" style="background: rgba(127, 220, 42, 0.62); width:100%; padding: 10px; margin-top: -20px;">
                <button type="button" class="button is-default" (click)="ctrl.agregar_form_array(ctrl.dato.controls.configuracion.controls.contactos, form_contactos)">
                  <i class="fa fa-plus"></i>
                </button>
              </div>
            </nav>

            <div class="field">
              <label class="label">Intro redes sociales:</label>
              <div class="control">
                <textarea class="textarea" rows="3" placeholder="Escriba un texto de introducción a las redes sociales"
                  formControlName="intro_redes">
                                </textarea>
              </div>
            </div>
            <!-- redes sociales -->
            <nav class="panel">
              <p class="panel-heading">
                Redes Sociales
              </p>
              <div class="panel-block">
                <table class="table is-striped  is-fullwidth" *ngIf="ctrl.dato.get('configuracion').value.redes_sociales.length > 0">
                  <thead>
                    <tr>
                      <th hide-sm>ID</th>
                      <th>Red</th>
                      <th>Valor</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody formArrayName="redes_sociales">
                    <tr *ngFor="let medio of ctrl.dato.controls.configuracion.controls.redes_sociales.controls; let suc = index"
                      [formGroupName]="suc">
                      <td>{{ suc + 1 }}</td>
                      <td>
                        <ng-select2 [disabled]="ctrl.tipos_redes_sociales ? ctrl.tipos_redes_sociales.length == 0 ? true : false : true" [options]="ctrl.optionSelect" [value]="medio.controls.tipos_redes_sociales_id.value"
                          (valueChanged)="ctrl.seleccionarValorSelect2($event, medio.controls.tipos_redes_sociales_id);"
                          [data]="ctrl.tipos_redes_sociales"></ng-select2>
                      </td>
                      <td>
                        <p class="control has-icon" *ngIf="ctrl.tipos_redes_sociales">
                          <input class="input" formControlName="valor" placeholder="Valor" [ngClass]="{'is-danger': !medio.controls.valor.valid}"
                            type="text">
                          <span class="icon is-small is-right">
                            <i [ngClass]="ctrl.tipos_redes_sociales[medio.controls.tipos_redes_sociales_id.value - 1]?.icon"></i>
                          </span>
                        </p>

                      </td>
                      <td align="right">
                        <button type="button" class="button is-danger" (click)="ctrl.quitar_form_array(ctrl.dato.controls.configuracion.controls.redes_sociales, suc)">
                          <i class="fa fa-trash-o"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="button is-primary is-outlined is-fullwidth" style="background: rgba(127, 220, 42, 0.62); width:100%; padding: 10px; margin-top: -20px;">
                <button type="button" class="button is-default" (click)="ctrl.agregar_form_array(ctrl.dato.controls.configuracion.controls.redes_sociales, form_redes_sociales)">
                  <i class="fa fa-plus"></i>
                </button>
              </div>
            </nav>
            <!-- mapa -->
            <div class="field">
              <label class="label">Mapa Embebido:</label>
              <div class="control">
                <textarea class="textarea" rows="3" placeholder="Mapa compartido de google maps" formControlName="iframe_map">
                                </textarea>
              </div>
            </div>
          </div>

        </section>
      </form>
    </div>
  </div>
</div>
